<template>
  <span>
    <b-btn
        @click="newItem"
        v-b-modal="'company-edit-' + id"
        :size="size"
        class="mt-2 mr-2"
        variant="dark"
        title="Nouvelle entreprise"
        aria-label="Nouvelle entreprise"
    ><b-icon-plus aria-hidden="true"/><slot></slot
    ></b-btn>
    <b-modal
        :id="'company-edit-' + id"
        title="Entreprise"
        no-fade
        size="lg"
        scrollable
        hide-footer
    >
      <form-admin-company
          :company="company"
          @saved="onSaved"
          @new="onNew"
          @update="onUpdate"
      />
    </b-modal>
  </span>
</template>

<script>
import formAdminCompany from './formAdminCompany.vue';

/**
* @vuese
* Bouton d'édition d'une entreprise
* @group COMPONENTS_ADMIN
*/
export default {
  name: 'BtnAdminCompanyEdit',
  components: {
    formAdminCompany
  },
  // Une entreprise
  props: {
    company: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    // Type de bouton
    variant: {
      type: String,
      default() {
        return 'link';
      }
    },
    // Identifiant d'une entreprise
    id: {
      type: String,
      default() {
        const rand = Math.random().toString(36).substring(2);
        return '' + rand;
      }
    },
    // Taille du bouton
    size: {
      type: String,
      default: () => 'md'
    }
  },
  methods: {
    /**
     * @vuese
     * Modification d'une entreprise
     */
    openItem() {
      // Ouverture de la fenêtre modale
      this.$root.$emit('bv::show::modal', 'company-edit-' + this.id);
    },
    /**
     * @vuese
     * Nouveau mot-clé
     */
    newItem() {
      this.company = {
        name: ''
      };
    },
    /**
     * @vuese
     * Sauvegarde d'une entreprise
     * @arg La entreprise
     */
    onSaved(item) {
      // Sauvegarde d'une entreprise
      // @arg La entreprise
      this.$emit('saved', item);
      // Fermeture de la fenêtre modale
      this.$root.$emit('bv::hide::modal', 'company-edit-' + this.id);
    },
    /**
     * @vuese
     * Mise à jour d'une entreprise
     * @arg La entreprise
     */
    onUpdate(item) {
      // Mise à jour d'une entreprise
      // @arg La entreprise
      this.$emit('update', item);
    },
    /**
     * @vuese
     * Nouvelle mot-clé
     * @arg La entreprise
     */
    onNew(item) {
      // Nouvelle entreprise
      // @arg La entreprise
      this.$emit('new', item);
    }
  }
};
</script>
